// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge{border:none;padding:7px;margin:5px;border-radius:10px;width:60%;height:20px;display:flex;justify-content:center;align-items:center}.badge span{font-weight:700;font-size:15px;color:#fff}.success{background-color:#4bb543}.info{background-color:#6495ed}.warning{background-color:#eed202}.warning span{color:#000}.danger{background-color:#f32013}", ""]);
// Exports
module.exports = exports;
